import { withNamespaces } from "react-i18next";
import { toast } from "react-toastify";
import { useCallback, useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import OverviewHeader from "src/modules/data-protection/pages/admin/software/overview-header";
import { useQuery } from "@tanstack/react-query";
import DataProtectionSoftwareService from "src/modules/data-protection/apis/DataProtectionSoftwareService";
import DPIAQuestionnaires from "./questionnaires";

const DPIA = (props) => {
    const { t, assetId } = props;

    const overviewHeaderRef = useRef();

    const [showImpactAssessment, setShowImpactAssessment] = useState(false);

    const handleFetchAssetBasicInformation = useQuery({
        queryKey: ["data-protection-asset-overview-content"],
        queryFn: async () => {
            const service = DataProtectionSoftwareService.getInstance();
            return await service.details(assetId);
        },
        cacheTime: 0,
        refetchOnWindowFocus: false,
        onError: () => {
            toast(t("An error occurred while fetching overview content."), {
                type: "error"
            });
        },
    });

    const onValidSubmit = useCallback((response) => {
        setShowImpactAssessment(!!response?.show_impact_assessment);

        if (overviewHeaderRef && overviewHeaderRef.current) {
            overviewHeaderRef.current.reload();
        }
    }, [])

    useEffect(() => {
        if (handleFetchAssetBasicInformation.data) {
            setShowImpactAssessment(
                handleFetchAssetBasicInformation.data?.show_impact_assessment
            )
        }
    }, [handleFetchAssetBasicInformation.data]);

    return (
        <div className="p-4">
            <OverviewHeader 
                assetId={assetId} 
                actionsRef={overviewHeaderRef}    
            />

            <DPIAQuestionnaires 
                showImpactAssessment={showImpactAssessment}
                onValidSubmit={onValidSubmit}
            />
        </div>
    );
};

const mapStatetoProps = (state) => {
    const { token, user } = state.Login;
    const { Organization, App } = state;

    return {
        token,
        user,
        Organization,
        App,
    };
};

export default withNamespaces()(withRouter(connect(mapStatetoProps, {})(DPIA)));
